<template>
  <v-card>
    <v-card-title class="primary white--text">
      <Icon
        icon="mdi-file-document-outline"
        iconColor="tertiary"
        :small="false"
      />
      <span class="mt-1 ml-1">
        {{ $t('kioskInstructions') }}
      </span>
    </v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-row dense>
          <v-col cols="10">
            <v-row dense>
              <v-col cols="12">
                <span :class="tractInstructions.kioskInstructions ? '' : 'subtitle-2 text-uppercase'">{{ tractInstructions.kioskInstructions || $t('noKioskInstructions') }}</span>
              </v-col>
            </v-row>
            <v-row dense class="mt-4">
              <v-col cols="12">
                <span class="subtitle-2 text-uppercase">{{ $t('completedTicketCopies') }}</span>
                <span v-if="tractInstructions.completedTicketPrintCount !== null && tractInstructions.completedTicketPrintCount !== undefined" class="subtitle-2">
                  &mdash; {{ $tc('nCopies', tractInstructions.completedTicketPrintCount) }}
                </span>
                <Icon
                  v-else
                  class="ml-2"
                  icon="mdi-information-outline"
                  :small="true"
                  style="display: inline-flex"
                  :tooltipText="$t('kioskDefaultDescription')"
                />
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="2" align="right">
            <div style="position:relative;">
              <Icon
                icon="mdi-pencil"
                iconColor="success"
                :small="false"
                :tooltipText="$t('edit')"
                :disabled="!userAssignedClaim(UserClaims.ContractManager)"
                @icon-clicked="$emit('edit-instructions')"
                elementId="edit-tract-instructions"
              />
              <Icon
                icon="mdi-delete-forever"
                iconColor="error"
                :small="false"
                :tooltipText="$t('delete')"
                :disabled="!userAssignedClaim(UserClaims.ContractManager)"
                @icon-clicked="$emit('delete-instructions')"
                elementId="delete-tract-instructions"
              />
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import { UserClaims } from '@/utils/Enumerations.js'
import { userAssignedClaim } from '@/utils/ClaimUtility.js'

export default {
  name: 'TractInstructionsCard',

  components: {
    Icon: () => import('@/components/helper/Icon.vue')
  },

  props: {
    tractInstructions: {
      type: Object,
      required: true
    }
  },

  data: () => ({
    UserClaims
  }),

  methods: {
    userAssignedClaim
  }
}
</script>
